import {
  DeleteFilled,
  EditOutlined,
  ExportOutlined,
  PlusCircleFilled,
  SyncOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Input,
  Button,
  Space,
  Table,
  Tag,
  Tooltip,
  Popconfirm,
  message,
  Card,
  Modal,
  Checkbox,
} from "antd";
import { useEffect, useState } from "react";
import "../Pages/CSS/DonnesBases.css";
import "../Pages/CSS/Traitement.css";
import { DemandeAgrService } from "../Services/DemandeAgrService";
import CreaFournDiv from "./CreaFournDiv";
import * as XLSX from "xlsx";
import dayjs from "dayjs"
import moment from "moment";
const DemandeAgr = () => {
  const initialTableData = [];
  const [totalFournisseurs, setTotalFournisseurs] = useState(0);
  const [showCreaFournDiv, setShowCreaFournDiv] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10)
  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);

  const demandeAgrService = new DemandeAgrService();

  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await demandeAgrService.getAllLDemandeAgr();
      setTableData(data);
      setTotalFournisseurs(data.length);
      setFilteredData(data);
    } catch (error) {
      message.error("Erreur lors du chargement des données");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered);
  };

  const handleResetAll = async () => {
    await fetchData();
  };

  const handleShowCreaFournDiv = () => {
    setSelectedRecord(null);
    setShowCreaFournDiv(true);
  };

  const handleEdit = async (record) => {
    try {
      const fetchedRecord = await demandeAgrService.getOneDemandeAgr(record.numFourn);
      setSelectedRecord(fetchedRecord);
      setShowCreaFournDiv(true);
    } catch (error) {
      console.error("Erreur lors de la récupération de la demande d'agrément :", error);
      message.error("Erreur lors de la récupération de la demande d'agrément");
    }
  };

  const handleDelete = async (record) => {
    try {
      await demandeAgrService.supDemandeAgr(record.numFourn);
      message.success("Demande d'agrément supprimé avec succès");
      await fetchData();
    } catch (error) {
      message.error("Erreur lors de la suppression du fournisseur");
    }
  };

  // Fonction pour obtenir toutes les colonnes possibles à partir des données
  const getAllColumns = (data) => {
    const keys = new Set();
    data.forEach(row => {
      Object.keys(row).forEach(key => keys.add(key));
    });
    return Array.from(keys).map(key => ({
      title: key,
      dataIndex: key,
      key: key
    }));
  };

  const allColumns = getAllColumns(tableData);

  useEffect(() => {
    setSelectedColumns(allColumns.map(col => col.key));
  }, [tableData]);

  const handleExport = () => {
    setExportModalVisible(true);
  };

  const handleExportSubmit = () => {
    const selectedData = filteredData.map((row) =>
      selectedColumns.reduce((acc, colKey) => {
        acc[colKey] = row[colKey];
        return acc;
      }, {})
    );

    const worksheet = XLSX.utils.json_to_sheet(selectedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "data.xlsx");

    setExportModalVisible(false);
  };

  const handleColumnChange = (checkedValues) => {
    setSelectedColumns(checkedValues);
  };

  const columns = [
    {
      title: "Numéro",
      dataIndex: "numFourn",
      key: "numFourn",
      className: "small-cell",
      ellipsis: true,
      sorter: (a, b) => (String(a.numFourn) || "").localeCompare(String(b.numFourn) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Date Demande",
      dataIndex: "date_dem_agreement",
      key: "date_dem_agreement",
      className: "small-cell",
      align: "center",
      ellipsis: true,
      render:  (text) => dayjs(text).format("DD/MM/YYYY"),
      sorter: (a, b) => {
        const dateA = a.date_dem_agreement ? new Date(a.date_dem_agreement) : 0;
        const dateB = b.date_dem_agreement ? new Date(b.date_dem_agreement) : 0;
        return dateA - dateB;
      },
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Agreer le",
      dataIndex: "date_agreement",
      key: "date_agreement",
      className: "small-cell",
      ellipsis: true,
      render: (text) => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
      sorter: (a, b) => {
        const dateA = a.date_agreement ? new Date(a.date_agreement) : 0;
        const dateB = b.date_agreement ? new Date(b.date_agreement) : 0;
        return dateA - dateB;
      },
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Raison Sociale",
      dataIndex: "raisoc",
      key: "raisoc",
      className: "small-cell",
      ellipsis: true,
      sorter: (a, b) => (String(a.raisoc) || "").localeCompare(String(b.raisoc) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Adresse",
      dataIndex: "adresse",
      key: "adresse",
      className: "small-cell",
      ellipsis: true,
      sorter: (a, b) => (String(a.adresse) || "").localeCompare(String(b.adresse) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Fixe.",
      dataIndex: "telFix",
      key: "telFix",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => (String(a.telFix) || "").localeCompare(String(b.telFix) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Portable",
      dataIndex: "portable",
      key: "portable",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => (String(a.portable) || "").localeCompare(String(b.portable) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Agrément",
      dataIndex: "agree",
      key: "agree",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      render: (agree) => {
        let color = "";
        let text = "";
  
        if (agree === "A") {
          color = "#67f02e";
          text = "Agréer";
        } else if (agree === "C") {
          color = "#e0ce07";
          text = "En cours";
        } else if (agree === "R") {
          color = "#fc0b03";
          text = "Rejeté";
        }
  
        return (
          <Tag color={color} key={agree}>
            {text}
          </Tag>
        );
      },
      sorter: (a, b) => (String(a.agree) || "").localeCompare(String(b.agree) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Specialité",
      dataIndex: "intitule",
      key: "intitule",
      className: "small-cell",
      ellipsis: true,
      sorter: (a, b) => (String(a.intitule) || "").localeCompare(String(b.intitule) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      // title: "Créer le",
      title: (
       <div
         style={{
           backgroundColor: " #010f1c",
           color: "white",
           paddingLeft: 5,
         }}
       >
        Créer le
       </div>
     ),
       dataIndex: "datecreation",
       key: "datecreation",
       align: "center",
       render: (text) => moment(text).format("DD/MM/YYYY"),
     },
     {
     //  title: "Saisie par",
     title: (
       <div
         style={{
           backgroundColor: " #010f1c",
           color: "white",
           paddingLeft: 5,
         }}
       >
        Saisie par
       </div>
     ),
       dataIndex: "created_by",
       key: "created_by",
       align: "center",
       
     },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      dataIndex: "actions",
      key: "actions",
      align: "center",
      render: (text, record) => {
        if (record.agree === "C" || record.agree === "R") {
          return (
            <span>
              <Tooltip title="Modifier">
                <EditOutlined
                  style={{ cursor: "pointer", color: "#1890ff", marginRight: 8 }}
                  onClick={() => handleEdit(record)}
                />
              </Tooltip>
              <Popconfirm
                title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
                onConfirm={() => handleDelete(record)}
                okText="Oui"
                cancelText="Non"
              >
                <Tooltip title="Supprimer">
                  <DeleteFilled style={{ cursor: "pointer", color: "red" }} />
                </Tooltip>
              </Popconfirm>
            </span>
          );
        } else {
          return null;
        }
      },
    },
  ];
  

  return (
    <div>
      {!showCreaFournDiv ? (
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={24}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={8} lg={8}>
                <label>Total Demandes : {totalFournisseurs}</label>
                <Row gutter={8} align="middle">
                  <Col xs={12}>
                    <Input
                      className="search-input-highlight"
                      placeholder="Rechercher..."
                      allowClear
                      prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                      style={{ width: "100%" }}
                      onChange={(e) => handleSearch(e.target.value)}
                      onPressEnter={(e) => handleSearch(e.target.value)}
                    />
                  </Col>
                </Row>
              </Col>

              <Col xs={24} sm={16} lg={16}>
                <Row justify="end">
                  <Col span={24} style={{ textAlign: "right" }}></Col>

                  <Col
                    span={24}
                    style={{ textAlign: "right", alignContent: "center" }}
                  >
                    <Space style={{ display: "flex", justifyContent: "flex-end" }}>
                      <Button size="small" className="buttonExport" icon={<ExportOutlined />} onClick={handleExport}>
                        Export Excel
                      </Button>
                      <Button
                        onClick={handleShowCreaFournDiv}
                        size="small"
                        style={{ backgroundColor: "#173beb", color: "white" }}
                        icon={<PlusCircleFilled />}
                      >
                        Nouveau
                      </Button>

                      <Button
                        onClick={handleResetAll}
                        icon={<SyncOutlined />}
                        size="small"
                       // style={{ backgroundColor: "#67f02e", color: "white" }}
                       className="buttonRefresh" 
                      >
                        Actualiser
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Card bordered={false}>
              <Table
                 scroll={{
                  x: true,
                }}
                showSorterTooltip={false}
     
      pagination={{
        pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
        showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
        pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
        onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
      }}
                style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
                className="custom-header1-table"
                bordered
                columns={columns}
                
                dataSource={filteredData}
                loading={loading}
              />
            </Card>
          </Col>
        </Row>
      ) : (
        <CreaFournDiv
          record={selectedRecord}
          onSuccess={() => {
            setShowCreaFournDiv(false);
            fetchData();
          }}
        />
      )}

      <Modal
        title="Sélectionner les colonnes à exporter"
        open={exportModalVisible}
        onCancel={() => setExportModalVisible(false)}
        onOk={handleExportSubmit}
      >
        <Checkbox.Group
          options={allColumns.map(col => ({ label: col.title, value: col.key }))}
          defaultValue={allColumns.map(col => col.key)}
          onChange={handleColumnChange}
        />
      </Modal>
    </div>
  );
};

export default DemandeAgr;
